import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import StaticFunctions from "../utils/StaticFunctions";

class LocationSelector extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    static defaultProps = {
        currentLocation: null,
        placeholder: 'Select...',
        onLocationSelected: PropTypes.func.isRequired,
        allLabel: 'all'
    };

    constructor(props) {

        super(props);

        this.state = {
            currentLocationId: this.props.currentLocation,
            companyLocations: this.props.baseData.companyLocations,
        };

        this.translate = this.props.baseData.translate;

        this.selectLocation = this.selectLocation.bind(this);

    }

    componentDidMount() {

        this.checkForValidSelection();

    }

    componentDidUpdate(prevProps, prevState) {

        this.checkForValidSelection();

    }

    checkForValidSelection() {

        if (this.state.currentLocationId !== 0 && this.getLocationById(this.state.currentLocationId) === false) {
            this.setState({
                currentLocationId: 0
            });

            if (this.props.onLocationSelected) this.props.onLocationSelected(null);
        }

    }

    selectLocation(location) {

        const newLocation = this.getLocationById(location.value);

        if (String(this.state.currentLocationId) === String(newLocation.id)) return;

        this.setState({currentLocationId: location.value});

        if (this.props.onLocationSelected) this.props.onLocationSelected(newLocation);

    }

    getCompanyLocations() {

        const currentCompany = this.props.baseData.companies ? this.props.baseData.companies.currentCompany : null;
        if (!currentCompany) return [];

        const userCompanyId = currentCompany.id;
        const locations = this.props.baseData.companyLocations ? this.props.baseData.companyLocations : [];
        const companyLocations = [];

        for (let ix in locations) {
            let location = locations[ix];

            if (String(location.id_company) === String(userCompanyId)) companyLocations.push(location);
        }

        return companyLocations;

    }

    getLocationById(id) {

        const opt = this.getCompanyLocations();

        if (parseInt(id) === 0) {
            return {
                id: id,
                name: this.translate(this.props.allLabel),
                id_company: null,
                date_deleted: null,
            };
        } else {
            for (let ix in opt) {
                let location = opt[ix];

                if (String(location.id) === String(id)) return location;
            }
        }

        return false;

    }

    getOptions() {

        const locations = this.getCompanyLocations();
        const locationOptions = locations.map(location => {
            return {
                value: String(location.id),
                label: (location.id === 0 && location.name === 'all') ? this.translate(location.name) : location.name
            }
        });
        const defaultOptions = [{
                value: 0,
                label: this.translate(this.props.allLabel)
        }];

        return defaultOptions.concat(locationOptions);

    }

    render() {
        const opts = this.getOptions();
        const sortedOpts = StaticFunctions.getSortedData(opts, 'label', 'string');
        const selectedOption = sortedOpts.find(o => String(o.value) === String(this.state.currentLocationId)) || null;

        return (
            <Select
                name="select-location"
                className="chosen-container chosen-container-single"
                style={{width: '260px'}}
                options={sortedOpts}
                onChange={this.selectLocation}
                value={selectedOption}
                placeholder={this.translate('select') + '...'}
                clearable={false}
                noResultsText={this.translate('noResultsFound')}
            />
        );
    }

}

export default LocationSelector;